import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import axios from 'axios';
//import DataModal from './DataModal/DataModal';

//axios.defaults.baseURL = (window.location.href.includes('localhost')) ? DataModal.SERVER_URL : DataModal.SERVER_URL

axios.interceptors.request.use(request =>{
  return request;
},error =>{
  return Promise.reject(error);
});

axios.interceptors.response.use(response =>{
    return response;
}, error =>{
  return Promise.reject(error);
});

const app = (
    <BrowserRouter>
      <App/>
    </BrowserRouter>
)
ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js